"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

//we'll re-export these for convenience in the babel6 world.
var string = _react.PropTypes.string;
var bool = _react.PropTypes.bool;
var number = _react.PropTypes.number;
var object = _react.PropTypes.object;
var func = _react.PropTypes.func;
var any = _react.PropTypes.any;
var node = _react.PropTypes.node;
var shape = _react.PropTypes.shape;
var arrayOf = _react.PropTypes.arrayOf;
var instanceOf = _react.PropTypes.instanceOf;
var oneOf = _react.PropTypes.oneOf;
var oneOfType = _react.PropTypes.oneOfType;


function customPropType(type, name) {
    function customPropType$return() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return type.apply(api, args);
    }

    customPropType$return.isRequired = function customPropType$return$isRequired() {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        return type.isRequired.apply(type, args);
    };
    if (name) customPropType$return.propTypeName = name;

    return customPropType$return;
}

function propTypeToName(propType) {
    var keys = Object.keys(api),
        l = keys.length;
    for (var i = 0; i < l; i++) {
        var key = keys[i],
            f = api[key];
        if (f.isRequired === propType) {
            return '*' + key;
        }
        if (f === propType) {
            return key;
        }
    }
}

function propTypesToNames(props) {
    return Object.keys(props).reduce(function (ret, k) {
        ret[k] = propTypeToName(props[k]);
        return ret;
    }, {});
}
var deprecated = function deprecated(message) {
    return function deprecated$propType(props, propName, componentName) {
        return propName in props ? new Error("DEPRECATED: " + message + " in " + componentName + ".propTypes." + propName) : void 0;
    };
};
var conditional = oneOfType([string, shape({
    operator: oneOfType([string, func])
})]);

var domType = customPropType(node, 'domType');

var fields = customPropType(arrayOf(string), 'fields');

var title = customPropType(oneOfType([string, bool]), 'title');

var injector = shape({
    inject: func.isRequired
});

var blurValidate = customPropType(func, 'blurValidate');

var changeValidate = customPropType(func, 'changeValidate');

var validate = customPropType(func, 'validate');

var value = customPropType(any, 'value');

var message = customPropType(any, 'message');

var error = customPropType(any, 'error');

var errors = customPropType(any, 'errors');

var promise = shape({ then: func });

var id = customPropType(string, 'id');

var htmlFor = customPropType(id, 'htmlFor');

var fieldAttrs = customPropType(object, 'fieldAttrs');

var cssClass = customPropType(string, 'cssClass');

var style = customPropType(object, 'style');

var typeClass = customPropType(cssClass, 'typeClass');

var templateClass = customPropType(cssClass, 'templateClass');

var injectedClass = customPropType(any, "injectedClass");

var event = customPropType(func, 'event');

var validator = customPropType(func, 'validator');

var path = customPropType(string, 'path');

var placeholder = customPropType(string, 'placeholder');

var arrayString = oneOfType([string, arrayOf(string)]);

var submit = customPropType(func, 'submit');

var listener = customPropType(any, 'listener');

/**
 * A valueEvent does not expect target.value
 */
var valueEvent = customPropType(func, 'valueEvent');

/**
 * A targetEvent expects the first arg to have target.value
 */
var targetEvent = customPropType(func, 'targetEvent');

/**
 * A errorEvent expects the first arg to be an error.
 */
var errorEvent = customPropType(func, 'errorEvent');

/**
 * Signify this is a blur Event Listener.
 */
var blurEvent = customPropType(func, 'blurEvent');

/**
 * Signify this is a onValid Event listener.
 */
var validEvent = customPropType(func, 'validEvent');

var dataType = customPropType(string, 'dataType');

var type = oneOfType([string, func]);

var typeDescription = oneOfType([string, shape({
    type: string.isRequired
})]);

var _transitionTypes = oneOf(['appear', 'enter', 'leave']);
var transition = oneOfType([_react.PropTypes.string, shape({
    transition: _react.PropTypes.string,
    on: _transitionTypes
})]);

/**
 * Signify this property can take an expression.  This
 * allows properties to be tied to the valueManager.  So
 * it will evaluate the property against the valueManager.
 *
 * It will add a listener for each of the corresponding
 * matching strings.
 *
 */
var expression = customPropType(string, 'expression');

var loader = shape({
    loadTemplate: func,
    loadType: func,
    loadSchema: func,
    loadValidator: func,
    loadProcessor: func,
    loadOperator: func
});

var valueManager = shape({
    addListener: func,

    addErrorListener: func,

    addValidateListener: func,

    addSubmitListener: func,

    addStateListener: func
});

var contentShape = {
    className: cssClass,
    type: string,
    children: bool
};

var pContentShape = shape(contentShape);

var contentType = oneOfType([pContentShape, string, bool, func, number, arrayOf(oneOfType([string, string, bool, number, func, pContentShape]))]);

contentShape.content = contentType;

var content = contentType;

var template = oneOfType([string, bool, shape({
    template: oneOfType([string, bool, func]),
    content: content,
    className: cssClass
}), func]);

var button = oneOfType([string, shape({
    onClick: event,
    buttonClass: cssClass,
    action: string,
    name: string,
    value: string,
    iconClass: cssClass
})]);

var buttons = oneOfType([button, arrayOf(button), shape({
    buttonsClass: cssClass,
    onButtonClick: event,
    buttons: oneOfType([arrayString, arrayOf(button)]),
    buttonTemplate: template,
    buttonsTemplate: template
})]);

var fieldset = shape({
    fields: arrayString,
    legend: content,
    className: cssClass,
    buttons: buttons,
    template: template
});

var literal = oneOfType([string, bool, number, instanceOf(Date)]);

var options = oneOfType([arrayString, arrayOf(shape({
    label: string,
    val: literal
}))]);

var optionsGroup = oneOfType([arrayString, arrayOf(shape({
    options: options,
    group: string,
    label: string,
    labelHTML: string,
    val: literal
}))]);

var schema = oneOfType([string, object, shape({
    fields: arrayString,
    fieldsets: oneOfType([arrayString, fieldset, arrayOf(fieldset)]),
    schema: object
})]);

var array = arrayOf(any);

var validators = oneOfType([arrayString, arrayOf(validators)]);

var operator = oneOfType([string, func, instanceOf(RegExp)]);

var events = {
    onValidate: event,
    onFocus: event,
    onBlur: event,
    onValid: event,
    onChange: oneOfType([targetEvent, valueEvent])
};

var field = customPropType(any, 'field');

var mixin = {
    events: events,
    field: _extends({}, events, {
        title: content,
        help: content,
        name: string,
        placeholder: placeholder,
        dataType: dataType,
        editorClass: cssClass,
        fieldClass: cssClass,
        field: {}
    })
};

var contextTypes = Object.freeze({
    valueManager: valueManager,
    loader: loader,
    injector: injector
});

var processor = oneOfType([string, shape({
    fetch: func,
    value: func,
    format: func
})]);

var injectClass = oneOfType([func, shape({
    injectClass: func,
    propTypes: object,
    injectProps: object,
    strict: bool
})]);

var api = {
    conditional: conditional,
    deprecated: deprecated,
    transition: transition,
    injectClass: injectClass,
    blurValidate: blurValidate,
    changeValidate: changeValidate,
    promise: promise,
    id: id,
    injectedClass: injectedClass,
    fieldAttrs: fieldAttrs,
    cssClass: cssClass,
    error: error,
    errors: errors,
    errorEvent: errorEvent,
    event: event,
    htmlFor: htmlFor,
    validator: validator,
    path: path,
    placeholder: placeholder,
    arrayString: arrayString,
    listener: listener,
    valueEvent: valueEvent,
    targetEvent: targetEvent,
    blurEvent: blurEvent,
    validEvent: validEvent,
    dataType: dataType,
    type: type,
    domType: domType,
    typeDescription: typeDescription,
    expression: expression,
    loader: loader,
    valueManager: valueManager,
    content: content,
    template: template,
    button: button,
    buttons: buttons,
    fields: fields,
    fieldset: fieldset,
    literal: literal,
    options: options,
    submit: submit,
    optionsGroup: optionsGroup,
    schema: schema,
    value: value,
    validate: validate,
    validators: validators,
    operator: operator,
    events: events,
    field: field,
    mixin: mixin,
    style: style,
    contextTypes: contextTypes,
    processor: processor,
    typeClass: typeClass,
    string: string, bool: bool, number: number, object: object, func: func, any: any, node: node, shape: shape, arrayOf: arrayOf, instanceOf: instanceOf, oneOfType: oneOfType, oneOf: oneOf

};

exports.default = {
    propTypesToNames: propTypesToNames,
    propTypeToName: propTypeToName,
    customPropType: customPropType,
    conditional: conditional,
    blurValidate: blurValidate,
    changeValidate: changeValidate,
    promise: promise,
    id: id,
    fieldAttrs: fieldAttrs,
    cssClass: cssClass,
    error: error,
    errors: errors,
    event: event,
    valueEvent: valueEvent,
    targetEvent: targetEvent,
    errorEvent: errorEvent,
    validator: validator,
    path: path,
    placeholder: placeholder,
    arrayString: arrayString,
    listener: listener,
    blurEvent: blurEvent,
    validEvent: validEvent,
    dataType: dataType,
    domType: domType,
    type: type,
    typeDescription: typeDescription,
    expression: expression,
    loader: loader,
    valueManager: valueManager,
    content: content,
    template: template,
    button: button,
    buttons: buttons,
    fields: fields,
    fieldset: fieldset,
    injectedClass: injectedClass,
    injector: injector,
    literal: literal,
    htmlFor: htmlFor,
    options: options,
    optionsGroup: optionsGroup,
    schema: schema,
    validators: validators,
    operator: operator,
    events: events,
    field: field,
    mixin: mixin,
    contextTypes: contextTypes,
    processor: processor,
    submit: submit,
    value: value,
    validate: validate,
    array: array,
    title: title,
    injectClass: injectClass,
    typeClass: typeClass,
    style: style,
    transition: transition,
    deprecated: deprecated,
    string: string, bool: bool, number: number, object: object, func: func, any: any, node: node, shape: shape, arrayOf: arrayOf, instanceOf: instanceOf, oneOfType: oneOfType, oneOf: oneOf
};
//# sourceMappingURL=index.js.map


/** WEBPACK FOOTER **
 ** ./~/subschema-prop-types/dist/index.js
 **/